import { decorate, observable } from 'mobx'
import * as React from 'react'
import styled from 'styled-components'

import { Content } from '../../atoms/Content/index'
import { Layout } from '../../atoms/Layout'
import { Nav } from '../../atoms/Nav'
import { ProfileDropdown } from '../../organisms/ProfileDropdown'
import Box, { Row } from '../../atoms/Box'
import MenuStore from '../../stores/MenuStore'
import MobileMenu from '../../atoms/MobileMenu'
import cardBackground from './kidsFaqBackground.svg'
import {Button} from '../../atoms/Button'
import {KidsPageCheck} from "../../atoms/KidsPageCheck";
import {withRouter} from "react-router";
import {Query} from '@apollo/client/react/components'
import {GET_OWN_INTAKE_QUERY} from "../../queries/GET_OWN_INTAKE_QUERY";
import {intakeMetrics} from "../../organisms/Intakes/intakeMetrics/calcIntakeMetrics";

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'en': {
    a1: 'When you’re finished taking the tour or playing a game or activity, you can click the video icon at the top. This will bring you back to Billy Bot and Tot-Bot on the home page.',
    a2: 'You sure can! If you’d like to practice the ‘’mask game’’, you can print out the coloring pages found on the Activities page. These include a mask, a doctor’s mask, and a hat. Have fun practicing!',
    a3: 'You can print your award certificate after you’ve watched all of the videos. Anna has so much to share with you, so make sure you watch and listen closely!',
    a3Pablo: 'You can print your award certificate after you’ve watched all of the videos. Pablo has so much to share with you, so make sure you watch and listen closely!',
   
    a4: 'You can watch the videos by clicking on the orange, purple, green and blue tabs on the video page.  If you have watched them all, you can print out an award certificate!',
    activities: 'Activities',
    games: 'Games',
    goBack: 'Go Back',
    q1:'How do I watch the videos',
    q2:`Can I participate in the "mask game" like Anna?`,

    q2Pablo:`Can I participate in the "mask game" like Pablo?`,
    q3: 'Why can’t I print out my award certificate?',
    q4: 'How do I go back to the home page?',
    title: 'Frequently asked questions',
    tour: 'Tour',
    video: 'Video',
    },
  'es': {
    a1: 'Puedes ver los videos haciendo clic en las pestañas naranja, morada, verde y azul en la página de videos. Si has visto todos, ¡puedes imprimir un certificado de premio!',
    a2: '¡Seguro que puedes! Si deseas practicar el "juego de máscaras", puede imprimir las páginas para colorear que se encuentran en la página de Actividades. Estos incluyen una mascarilla de dormir, mascarilla de doctor, y un gorro de doctor. ¡Diviértete practicando!',
    a3: `Puedes imprimir tu certificado de premio después de haber visto todos los videos. Anna tiene mucho que compartir contigo, ¡así que asegúrate de mirar y escuchar atentamente!`,
    a3Pablo: 'Puedes imprimir tu certificado de premio después de haber visto todos los videos. Pablo tiene mucho que compartir contigo, ¡así que asegúrate de mirar y escuchar atentamente!',
    a4: 'Cuando hayas terminado de hacer el recorrido o jugar un juego o actividad, puedes hacer clic en el icono de video en la parte superior. Esto te llevará de regreso a Billy Bot y Tot-Bot en la página de inicio.',
    activities: 'Actividades',
    games: 'Juegos',
    goBack: 'Ir Atrás',
    q1:'¿Cómo veo los videos?',
    q2:`¿Puedo participar en el "juego de máscaras" como Anna?`,
    q2Pablo:`¿Puedo participar en el "juego de máscaras" como Pablo?`,
    q3: '¿Por qué no puedo imprimir mi certificado de premio?',
    q4: '¿Cómo vuelvo a la página de inicio?',
    title: 'Preguntas frecuentes',
    tour: 'Recorrido',
    video: 'Video',
    },
}

const BearOne = styled.img`
  position: absolute;
  right: -20px;
  top: -20px;
  width: 60px;
`

const BearTwo = styled.img`
  position: absolute;
  left: -20px;
  bottom: 10px;
  width: 55px;
`

const BearThree = styled.img`
  position: absolute;
  left: -20px;
  bottom: 10px;
    width: 145px;
    top: -19px;
    left: 60%;
`

const BearFour = styled.img`
    position: absolute;
    bottom: 10px;
    width: 100px;
    top: -19px;
    right: 0px;
    top: 20px;
    width: 75px;
    top: 10%;
`

const Hero = styled.img`
    position: absolute;
    bottom: 10px;
    width: 100px;
    right: 0px;
    width: 75px;
    border: -10px;
    bottom: -17px;
    width: 200px;
    right: -22px;
`

const Mooze = styled.img`
    position: absolute;
    width: 75px;
    border: -10px;
    width: 100px;
    top: 50%;
    left: -46px;
`

// tslint:disable:max-line-length object-literal-sort-keys
const HomeImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

const Title = styled.h1`
  text-align: left !important;
  font-family: Nunito;
  font-weight: 900;
  font-size: 54px;
  color: #043E74;
`
// TODO media query
const TextContainer = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    position: relative;
    background: #C7F0F6;
    min-height: 500px;
    top: 20px;
    border-radius: 10px;
    padding-top: 30px;
    z-index: 1;

    background: #DAF5F8
`

const OrangePoint = styled.div`
    margin-right: 9px;
    background: #FC9426;
    font-family: Nunito-Black;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    height: 30px;
    width: 30px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
`

const Question = styled.div`
  font-size: 20px;
  color: #12385B;
  line-height: 24px;
  font-weight: 800;
`

const Answer = styled.div`
  font-size: 18px;
  color: #172129;
  letter-spacing: 0;
  line-height: 24px;
`

class FaqPage extends React.Component {
  menuStore

  constructor (props) {
    super(props)
    this.menuStore = MenuStore.create({})
  }

  render () {
    const { isPablo } = this.props
    
    let ContentClass = KidsDesktop

    if (window.innerWidth <= 550) {
      ContentClass = KidsMobile
    }

    return (
      <Layout hasKidBackground>
        <Nav.KidsBar>
          <Nav.KidsSite
            onClick={() => {
              this.menuStore.showMenu()
            }}
          />
          <Nav.KidsButton link="/kids-video" name="navBarVideo" text={`${translations[lang].video}`} />
          <Nav.KidsButton link="/kids-tour" name="navBarTourActive" text={`${translations[lang].tour}`} />
          <Nav.KidsButton link="/kids-games" name="navBarGames" text={`${translations[lang].games}`} />
          <Nav.KidsButton link="/kids-activities" name="navBarActivities" text={`${translations[lang].activities}`} />
          <ProfileDropdown color='#CEE3F9' />
        </Nav.KidsBar>
        <MobileMenu store={this.menuStore} />
        <ContentClass isPablo={isPablo}/>
      </Layout>
    )
  }
}

const KidsDesktop = (props) => {
  const { isPablo } = props
  return (
    <Content>
      <div style={{ position: 'relative' }}>
        <TextContainer>
          <div style={{ position: 'relative', zIndex: 10, paddingLeft: 40, paddingRight: 40, paddingBottom: 40 }}>
            <div class='row'>
              <div class='col-6'>
                <Title>{translations[lang].title}</Title>
                <OrangePoint>2</OrangePoint>
                <Box h={20} />
                <Box style={{ flex: 1 }}>
                  <Question style={{ paddingRight: 20 }} >{isPablo ? translations[lang].q2Pablo : translations[lang].q2}</Question>
                  <Box h={3} />
                  <Answer>
                    {translations[lang].a2}
                  </Answer>
                </Box>
                <Box h={40} />
                <OrangePoint>4</OrangePoint>
                <Box h={20} />
                <Box style={{ flex: 1 }}>
                  <Question>{translations[lang].q4}</Question>
                  <Box h={3} />
                  <Answer>
                    {translations[lang].a4}
                  </Answer>
                </Box>

              </div>
              <div class='col-6'>
                <OrangePoint>1</OrangePoint>
                <Box h={20} />
                <Box style={{ flex: 1 }}>
                  <Question>{translations[lang].q1}</Question>
                  <Box h={3} />
                  <Answer>
                    {translations[lang].a1}
                  </Answer>
                </Box>
                <Box h={40} />
                <OrangePoint>3</OrangePoint>
                <Box h={20} />
                <Box style={{ flex: 1 }}>
                  <Question>{translations[lang].q3}</Question>
                  <Box h={3} />
                  <Answer>
                  {isPablo ? translations[lang].a3Pablo : translations[lang].a3}
                  </Answer>
                </Box>

              </div>

            </div>
          </div>
          <HomeImage id='image' src={cardBackground} alt='' />
          <Box h={20} />
          <BearThree src='https://uci-images.s3-us-west-1.amazonaws.com/images/bear3.svg' />
          <BearFour src='https://uci-images.s3-us-west-1.amazonaws.com/images/bear4.svg' />
          <Hero
            src='https://uci-images.s3-us-west-1.amazonaws.com/images/hero.png'
            srcSet='https://uci-images.s3-us-west-1.amazonaws.com/images/hero@2x.png 2x'
          />

          <Mooze
            src='https://uci-images.s3-us-west-1.amazonaws.com/images/mooze.svg'
          />
        </TextContainer>

      </div>
      <Box h={20} />
      <Button style={{marginTop: 30}} onClick={() => window.history.back()}>{translations[lang].goBack}</Button>
    </Content>)
}

const KidsMobile = (props) => {
  const { isPablo } = props
  return (
    <Content>
      <div style={{ position: 'relative' }}>
        <TextContainer>
          <div style={{ position: 'relative', zIndex: 10 }}>
            <Title>Frequently asked questions</Title>
            <Row>
              <OrangePoint>1</OrangePoint>
              <Box style={{ flex: 1 }}>
                <Question>{translations[lang].q1}</Question>
                <Box h={3} />
                <Answer>
                  {translations[lang].a1}
                </Answer>
              </Box>
            </Row>
            <div style={{ position: 'relative' }}>
              <Box h={27} />
              <Row>
                <OrangePoint>2</OrangePoint>
                <Box style={{ flex: 1 }}>
                  <Question style={{ paddingRight: 20 }} >{isPablo ? translations[lang].q2Pablo : translations[lang].q2}</Question>
                  <BearOne src='https://uci-images.s3-us-west-1.amazonaws.com/images/bearOne.svg' />
                  <Box h={3} />
                  <Answer>
                    {translations[lang].a2}
                  </Answer>
                </Box>
              </Row>
            </div>
            <Box h={27} />

            <div style={{ position: 'relative' }}>
              <Row>
                <OrangePoint>3</OrangePoint>
                <Box style={{ flex: 1 }}>
                  <Question>{translations[lang].q3}</Question>
                  <Box h={3} />
                  <Answer>
                    {isPablo ? translations[lang].a3Pablo : translations[lang].a3}
                  </Answer>
                </Box>
              </Row>

              <Box h={27} />
              <BearTwo src='https://uci-images.s3-us-west-1.amazonaws.com/images/bearTwo.svg' />
            </div>

            <Row>
              <OrangePoint>4</OrangePoint>
              <Box style={{ flex: 1 }}>
                <Question>{translations[lang].q4}</Question>
                <Box h={3} />
                <Answer>
                  {translations[lang].a4}
                </Answer>
              </Box>
            </Row>

          </div>
          <HomeImage id='image' src={cardBackground} alt='' />
          <Box h={40} />
        </TextContainer>
        <Box h={20} />
        <Button style={{marginTop: 30}} onClick={() => window.history.back()}>Go Back</Button>
      </div>
    </Content>
  )
}

decorate(FaqPage, {
  menuStore: observable
})

const KidsFaqPage = withRouter(
  class Page extends React.Component {
    render () {
      return (
        <Query query={GET_OWN_INTAKE_QUERY}>{({ data, loading, error }) => {
          if (loading) { return null }
          if (error || !data || !data.getOwnIntake) { window.location.reload() }
          const intake = data.getOwnIntake
          const {
            section4ReviewCompleted
          } = intakeMetrics(intake)

          if (!section4ReviewCompleted) {
            this.props.history.replace('/kids-forbidden')
            return <div />
          }

          return (
            <FaqPage isPablo={intake.characterChoice === 'pablo'} />
          )
        }}
        </Query>
      )
    }
  }
)

export { KidsFaqPage }



// WEBPACK FOOTER //
// ./src/pages/KidsFaq/index.js